<template>
	<b-list-group class="d-flex flex-row justify-content-between">
		<div class="d-flex flex-row">
			<b-btn
				size="sm"
				pill
				class="mb-2 mr-2"
				@click="model = !model"
				:variant="model ? 'primary' : 'light'"
			>
				<md-icon
					class="mt-1"
					:icon="model ? 'expand_less' : 'expand_more'"
				/>
			</b-btn>
			<h5 class="mt-1">{{ title }}</h5>
		</div>
		<b-form-checkbox
			class="mr-3 mt-1"
			:value="true"
			:unchecked-value="false"
			:checked="check"
			@change="$emit('check',$event)"
		>
		</b-form-checkbox>
	</b-list-group>
</template>

<script>
export default {
	props: {
		value: Boolean,
		title: String,
		check: Boolean
	},
	computed:{
		model:{
			get(){
				return this.value
			},
			set(v){
				this.$emit('input',v)
			}
		}
	}
};
</script>

<style></style>
